var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "base-editor",
        {
          attrs: {
            mpeStriped: _vm.mpeStriped,
            basic: _vm.basic,
            submitDisabled: _vm.submitDisabled
          },
          on: {
            updateField: _vm.updateMpeParams,
            saveChanges: _vm.saveChanges,
            discardChanges: _vm.discardChanges,
            duplicateMpe: _vm.duplicateMpe
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "post-content" }, slot: "post-content" },
            [
              _c("h3", { staticClass: "mt-1" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("Button.edit")) + "\n      "
                )
              ]),
              _vm._v(" "),
              _vm._t("above", null, { params: _vm.getPayload }),
              _vm._v(" "),
              _c(
                _vm.componentByType,
                _vm._g(
                  {
                    tag: "component",
                    attrs: {
                      payload: _vm.getPayload,
                      availableImages: _vm.getAvailableImages,
                      selectedImages: _vm.getSelectedImages
                    }
                  },
                  _vm.$listeners
                )
              )
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-5 mpe-preview" },
        [
          _c("channel-preview", {
            attrs: { channel: _vm.makePreviewChannel, mpe: _vm.makePreviewMpe }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21ad1c1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ad1c1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/formatter/BasicFormatter.vue
// module id = null
// module chunks = 